/* window.BotClone: страница собрана компонентом, контракт PAGES тот же (init, mount, fill, voices, clones). */
import { definePageModule } from '../../bridge/page-module';
import { isServerMode } from '../../platform/server-mode';
import { Clone } from './Clone';
import { cloneServer, type CloneServer } from './clone-server';
import { createClone } from './engine';

export interface CloneApi {
  prepare: () => string;
  attach: () => void;
  init: (o: BotPageUi & { server?: CloneServer }) => void;
  load: () => Promise<void>;
  unmount: () => void;
  fill: (k: string) => void;
  voices: () => unknown[];
  clones: () => unknown[];
  blocks: (id: unknown) => unknown;
  refresh: () => void;
  leave: () => void;
  remove: (id: unknown) => void;
  rename: (id: unknown, name: string) => void;
  drop: (id: unknown) => Promise<unknown>;
  preview: (id: unknown) => Promise<string | null>;
  delText: (id: unknown) => string;
  limits: { free: number; sub: number };
  limit: () => number | null;
  readonly loaded: boolean;
  canCreate: () => boolean;
  MYV: unknown[];
}

const installed = window as unknown as { __steosCloneApi?: CloneApi };
let api: CloneApi | undefined = installed.__steosCloneApi;

/** Экран берёт api при отрисовке: installClone уже вызван */
export function cloneApi() {
  const current = api ?? installed.__steosCloneApi;
  if (!current) throw new Error('Clone page is not installed');
  return current;
}

export function installClone() {
  const b = createClone() as CloneApi;
  api = b;
  installed.__steosCloneApi = b;
  // Раздел один и тот же: в серверной сборке данные идут из API, в прототипе — из демо-слоя.
  if (isServerMode()) b.init({ server: cloneServer } as BotPageUi & { server: CloneServer });
  definePageModule({
    global: 'BotClone',
    PREFIX: '',
    TESTS: [],
    S: {},
    Page: Clone,
    init(o) {
      b.init(o);
    },
    fill(k) {
      b.fill(String(k));
    },
    beforeUnmount() {
      b.unmount();
    },
    extra: {
      load: b.load,
      voices: b.voices,
      clones: b.clones,
      blocks: b.blocks,
      refresh: b.refresh,
      leave: b.leave,
      limits: b.limits,
      limit: b.limit,
      get loaded() {
        return b.loaded;
      },
      canCreate: b.canCreate,
      remove: b.remove,
      rename: b.rename,
      drop: b.drop,
      preview: b.preview,
      delText: b.delText,
      MYV: b.MYV,
    },
  });
}
